import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { toOptimizedAssetUrl } from '../utils/baseUrl';
import { applyImageFallback } from '../utils/imageFallback';

export default function CartDrawer({ open, onClose }) {
  const { cart, removeFromCart, updateCartQty, user } = useApp();
  const navigate = useNavigate();
  const items = cart?.items || [];
  const [isMobile, setIsMobile] = React.useState(() => window.innerWidth <= 600);

  React.useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <>
      {open && <div className="overlay" onClick={onClose} style={{ zIndex: 450 }} />}
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, width: isMobile ? '100vw' : 440,
        maxWidth: '100vw', background: 'var(--cream)', zIndex: 500,
        display: 'flex', flexDirection: 'column',
        transform: open ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.38s cubic-bezier(0.4,0,0.2,1)',
        boxShadow: open ? 'var(--shadow-lg)' : 'none',
      }}>
        {/* Header */}
        <div style={{ padding: isMobile ? '18px 20px' : '22px 28px', borderBottom: '1px solid var(--border-soft)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'white' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-serif)', fontSize: isMobile ? 18 : 20, fontWeight: 400, letterSpacing: 0.5 }}>Your Bag</div>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', letterSpacing: '1.5px', textTransform: 'uppercase', marginTop: 3 }}>{items.length} {items.length === 1 ? 'item' : 'items'}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 6 }}>
            <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
          </button>
        </div>

        {/* Items */}
        <div style={{ flex: 1, overflowY: 'auto', padding: isMobile ? '8px 20px' : '8px 28px' }}>
          {items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '64px 0' }}>
              <div style={{ fontSize: 44, marginBottom: 16, opacity: 0.3 }}>◇</div>
              <div style={{ fontFamily: 'var(--font-serif)', fontSize: 20, marginBottom: 8 }}>Your bag is empty</div>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24 }}>Discover pieces crafted for you</p>
              <button className="btn btn-primary" onClick={() => { navigate('/collections'); onClose(); }}>Explore Collections</button>
            </div>
          ) : items.map(item => (
            <div key={item.id} style={{ display: 'flex', gap: 16, padding: '20px 0', borderBottom: '1px solid var(--border-soft)', flexDirection: isMobile ? 'column' : 'row' }}>
              <div style={{ width: isMobile ? '100%' : 84, height: isMobile ? 220 : 106, borderRadius: 4, overflow: 'hidden', background: 'var(--cream-deep)', flexShrink: 0 }}>
                {toOptimizedAssetUrl(item.product.thumbnailImage, { width: isMobile ? 900 : 420, quality: 70, format: 'webp' })
                  ? <img src={toOptimizedAssetUrl(item.product.thumbnailImage, { width: isMobile ? 900 : 420, quality: 70, format: 'webp' })} alt={item.product.name} loading="lazy" decoding="async" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={applyImageFallback} />
                  : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, opacity: 0.3 }}>◇</div>}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: 4 }}>{item.product.category}</div>
                <div style={{ fontFamily: 'var(--font-serif)', fontSize: 15, marginBottom: 10, lineHeight: 1.3 }}>{item.product.name}</div>
                <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', gap: 12, flexDirection: isMobile ? 'column' : 'row' }}>
                  <div style={{ display: 'flex', alignItems: 'center', border: '1px solid var(--border-soft)', borderRadius: 3 }}>
                    <button onClick={() => updateCartQty(item.id, item.quantity - 1)} style={{ width: 30, height: 30, background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--text-muted)' }}>−</button>
                    <span style={{ width: 26, textAlign: 'center', fontSize: 13 }}>{item.quantity}</span>
                    <button onClick={() => updateCartQty(item.id, item.quantity + 1)} style={{ width: 30, height: 30, background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--text-muted)' }}>+</button>
                  </div>
                  <span style={{ fontSize: 14, fontWeight: 500 }}>₹{(item.product.price * item.quantity).toLocaleString('en-IN')}</span>
                </div>
              </div>
              <button onClick={() => removeFromCart(item.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', alignSelf: 'flex-start', padding: 4, transition: 'color 0.2s' }}
                onMouseEnter={e => e.target.style.color = '#c0392b'}
                onMouseLeave={e => e.target.style.color = '#ccc'}>
                <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
              </button>
            </div>
          ))}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div style={{ padding: isMobile ? '20px' : '24px 28px', borderTop: '1px solid var(--border-soft)', background: 'white' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <span style={{ fontSize: 11, letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--text-muted)' }}>Total</span>
              <span style={{ fontFamily: 'var(--font-serif)', fontSize: 24 }}>₹{Number(cart?.total || 0).toLocaleString('en-IN')}</span>
            </div>
            <button className="btn btn-primary" style={{ width: '100%', padding: '16px', letterSpacing: '2.5px' }}
              onClick={() => { navigate(user ? '/checkout' : '/login'); onClose(); }}>
              {user ? 'Proceed to Checkout' : 'Sign In to Checkout'}
            </button>
            <button className="btn-ghost" style={{ width: '100%', textAlign: 'center', marginTop: 10, fontSize: 11, letterSpacing: '1.5px' }}
              onClick={() => { navigate('/shop'); onClose(); }}>Continue Shopping</button>
          </div>
        )}
      </div>
    </>
  );
}